import { ApplicationTable } from "@/components/data-table/predefined/application-table";
import { DataTableHeightMode } from "@/components/data-table/types";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";

export function ApplicationView() {
  const [_, navigate] = useLocation();
  const { t } = useTranslation(["ram", "common"]);

  return (
    <CenteredLayout
      variant={CenteredLayoutVariant.Table}
      title={t("ram:Apps")}
      subTitle={t("common:SearchFilterAndManageEntriesDescription")}
    >
      <ApplicationTable
        onRowNavigate={(application) => `~/ram/application/${application.uuid}/app-role`}
        onEdit={(application) => navigate(`/${application.uuid}/update`)}
        customRowActions={(row) => [
          {
            label: t("ram:AppRegistration"),
            icon: <ExternalLink className="h-4 w-4" />,
            onClick: () =>
              window.open(
                `https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/Overview/appId/${row.original.azureClientUuid}`,
                "_blank",
                "noopener,noreferrer",
              ),
          },
          {
            label: t("ram:EnterpriseApp"),
            icon: <ExternalLink className="h-4 w-4" />,
            onClick: () =>
              window.open(
                `https://portal.azure.com/#view/Microsoft_AAD_IAM/ManagedAppMenuBlade/~/Overview/objectId/${row.original.azureEnterpriseObjectUuid}/appId/${row.original.azureClientUuid}`,
                "_blank",
                "noopener,noreferrer",
              ),
          },
        ]}
        heightMode={DataTableHeightMode.Content}
      />
    </CenteredLayout>
  );
}
